import React from 'react';

const Message = (props) => {
  const { children, className } = props;
  return <div className={`message ${className !== undefined ? className : ''}`}>{children}</div>;
};

export default Message;
